/**
 * Fitnesspilot
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists, mapValues } from "../runtime";
import { ActivityExecutionFromJSON, ActivityExecutionToJSON, } from "./ActivityExecution";
import { ActivityMaxFromJSON, ActivityMaxToJSON, } from "./ActivityMax";
import { BodyDataFromJSON, BodyDataToJSON, } from "./BodyData";
import { MuscleStatusFromJSON, MuscleStatusToJSON, } from "./MuscleStatus";
import { UserDataFromJSON, UserDataToJSON, } from "./UserData";
/**
 * Check if a given object implements the RecommendationRequest interface.
 */
export function instanceOfRecommendationRequest(value) {
    let isInstance = true;
    isInstance = isInstance && "bodyData" in value;
    isInstance = isInstance && "muscleStatus" in value;
    isInstance = isInstance && "activityMaxes" in value;
    isInstance = isInstance && "userData" in value;
    return isInstance;
}
export function RecommendationRequestFromJSON(json) {
    return RecommendationRequestFromJSONTyped(json, false);
}
export function RecommendationRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        bodyData: BodyDataFromJSON(json.bodyData),
        muscleStatus: mapValues(json.muscleStatus, MuscleStatusFromJSON),
        activityMaxes: mapValues(json.activityMaxes, ActivityMaxFromJSON),
        userData: UserDataFromJSON(json.userData),
        activities: !exists(json, "activities")
            ? undefined
            : json.activities === null
                ? null
                : json.activities.map(ActivityExecutionFromJSON),
    };
}
export function RecommendationRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        bodyData: BodyDataToJSON(value.bodyData),
        muscleStatus: mapValues(value.muscleStatus, MuscleStatusToJSON),
        activityMaxes: mapValues(value.activityMaxes, ActivityMaxToJSON),
        userData: UserDataToJSON(value.userData),
        activities: value.activities === undefined
            ? undefined
            : value.activities === null
                ? null
                : value.activities.map(ActivityExecutionToJSON),
    };
}
